import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconCheckmark = ({ color }) => {
  const colorCode = colorLookup(color) ?? colorLookup('blue');
  return (
    <SVG width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.96036 10.2227C5.13708 10.4003 5.37674 10.5 5.62666 10.5C5.87662 10.5 6.11624 10.4003 6.29295 10.2227L14.3604 2.11637C14.7284 1.7466 14.7284 1.14711 14.3604 0.777341C13.9924 0.407575 13.3957 0.407531 13.0277 0.777341L5.62666 8.21421L2.60858 5.18151C2.24059 4.8117 1.64398 4.8117 1.27599 5.18151C0.908003 5.55128 0.908003 6.15077 1.27599 6.52054L4.96036 10.2227Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.5"
      />
    </SVG>
  );
};

export { IconCheckmark as default, IconCheckmark };
